import axios from "axios";
import day from 'dayjs'

export default {
    state: {
        orders: [],
        reminders: [],
        queryOptions: {
            prevKey: 'orders.id',
            queryKey: 'orders.id',
            queryOrder: 'desc',
            queryText: null,
            displayDone: true,
            page: 1
        }
    },
    mutations: {
        setOrders: function(state, payload) {
            state.orders = payload
        },
        setReminders: function(state, payload) {
            state.reminders = payload
        },
        setOrderQueryOptions: function(state, payload) {
            state.queryOptions = payload
        }
    },
    getters: {
        getOrderQueryOptions: async function(state) {
            return state.queryOptions
        },
        getOrders: async function(state) {
            return state.orders
        },
        getReminders: async function(state) {
            return state.reminders
        },
        getDisplayDone: async function(state) {
            return state.queryOptions.displayDone
        }
    },
    actions: {
        getOrders({ state, commit }) {

            const queryOptions = state.queryOptions

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.getters.getAccessToken
                },
                url: this.getters.getApiUrl + '/api/v1/order/getOrders',
                data: queryOptions,
                timeout: this.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data && response.data.status != '9999') {

                    const tmpResult = response.data
                    const tmpOrders = []

                    let i = 0
                    for (const item of response.data.data) {

                        item.estimateDate = day(item.estimateDate).format('YY/MM/DD')
                        item.dueDate = day(item.dueDate).format('YY/MM/DD')

                        tmpOrders[i] = item

                        i++

                    }

                    tmpResult.data = tmpOrders

                    commit('setOrders', tmpResult)

                }else{

                    commit('setOrders', [])

                }

            })

        },
        getReminders({ commit }) {

            return axios({
                method: 'GET',
                headers: {
                    'Authorization': 'bearer ' + this.getters.getAccessToken
                },
                url: this.getters.getApiUrl + '/api/v1/order/getReminders',
                timeout: this.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status == '0000'){

                    commit('setReminders', response.data.reminders)

                }else{

                    commit('setReminders', [])

                }

            })

        },
        setOrderQueryOptions({ commit }, payload) {
            commit('setOrderQueryOptions', payload)
        },
        setDisplayDone({ commit }, payload) {
            commit('setDisplayDone', payload)
        }
    }
}